import { ActionTree } from "vuex";
import axios, { AxiosResponse } from "axios";
import { RootState } from "@/store/types";
import {
  DetailIncomingItem,
  DetailIncomingItemInfo,
  DetailIncomingFilterParams,
  StatisticState,
  GroupIncomingFilterParams,
  GroupIncomingItem,
} from "./types";

export const actions: ActionTree<StatisticState, RootState> = {
  async getStatisticDetailIncoming(
    { commit },
    data: { filter: DetailIncomingFilterParams; transport: string }
  ) {
    commit("setLoading", true);
    try {
      let resp = await axios({
        url: `/stats-api/detail/${data.transport.toLowerCase()}`,
        params: data.filter,
      });
      let messages = resp.data?.messages ?? [];
      if (data.filter.page_number > 1) {
        commit("pushStatisticDetailIncoming", messages);
      } else {
        commit("setStatisticDetailIncoming", messages);
      }
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async getStatisticDetailIncomingInfo(
    { commit },
    data: { id: string; transport: string }
  ) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<DetailIncomingItemInfo> = await axios({
        url: `/stats-api/detail/${data.transport.toLowerCase()}/`.concat(encodeURIComponent(data.id)),
      });
      return resp.data;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async exportStatisticDetailIncoming(
    { commit },
    data: { filter: DetailIncomingFilterParams; transport: string }
  ) {
    commit("setLoading", true);
    try {
      let resp: AxiosResponse<{ status: string }> = await axios({
        url: `/stats-api/detail/${data.transport.toLowerCase()}/export`,
        params: data.filter,
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async getStatisticGroupIncoming(
      { commit },
      data: { filter: GroupIncomingFilterParams; transport: string }
  ) {
    commit("setLoading", true);
    try {
      let resp: AxiosResponse<{
        messages_count: number;
        messages: GroupIncomingItem[];
      }> = await axios({

        url: `/stats-api/group/${data.transport.toLowerCase()}`,
        params: data.filter ? data.filter : null,
      });
      commit("setStaticGroupIncoming", resp.data.messages);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async exportStatisticGroupIncoming(
      { commit },
      data: { filter: GroupIncomingFilterParams; transport: string }
  ) {
    commit("setLoading", true);
    try {
      let resp: AxiosResponse<{ status: string }> = await axios({
        url: `/stats-api/group/${data.transport.toLowerCase()}/export`,
        params: data.filter,
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },

  resetStatisticDetailIncomingState({ commit }) {
    commit("resetStatisticDetailIncomingState");
  },
};
